import axios from "axios";

export const ApiCallPost = async (url, parameters, headers) => {
  try {
    const response = await axios.post(url, parameters, { headers: headers });
    return response?.data;
  } catch (error) {
    return { success: false, message: error?.response?.data?.message || "An error occurred" };
  }
};